/* eslint-disable @1js/office-online-rules/no-v8-imports-for-fluentui */
import { memoizeFunction } from "@fluentui/react";

import type { SetTooltipProps } from "@1js/acui-common";

import type { AppContextType, ContextLogger } from "./AppContext";

/**
 * React context uses shallow props comparison to determine when to re-render children. If the value of the
 * context provider is not the same reference as the last reference value, there will always be a re-render.
 */
export const makeAppContextValue = memoizeFunction(
  (
    isExperimentalFeatureEnabled:
      | ((feature: string, defaultValue?: boolean) => boolean)
      | undefined,
    setTooltipElement: ((tooltipProps: SetTooltipProps) => void) | undefined,
    updateTooltipsHidden: ((hideAllTooltips: boolean) => void) | undefined,
    localWindow: Window | undefined,
    isPlatformFeatureEnabled?:
      | ((feature: string, defaultValue?: boolean) => boolean)
      | undefined,
    responsiveClassName?: string,
    logger?: ContextLogger
  ): AppContextType => {
    const appWindow: Window = localWindow ?? window;

    return {
      isExperimentalFeatureEnabled,
      isPlatformFeatureEnabled,
      setTooltipElement,
      updateTooltipsHidden,
      appWindow,
      responsiveClassName,
      logger,
    };
  }
);
